import ContentLoader from "react-content-loader";

import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
  height?: number | string;
  width?: number | string;
};

export const Skeleton = (props: Props) => {
  const { className, width = 336, height = 178 } = props;

  return (
    <div
      className={twMerge(
        "relative z-10 flex w-full items-center justify-center",
        className
      )}
    >
      <ContentLoader
        backgroundColor="white"
        className="rounded-xl"
        foregroundColor="#F7F4F2"
        height={height}
        preserveAspectRatio="none"
        title=""
        viewBox={`0 0 336 178`}
        width={width}
      >
        <rect height={height} rx="12" ry="12" width={width} x="0" y="0" />
      </ContentLoader>
    </div>
  );
};
